import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { UserApplications } from '@workspace/data-types';
import { ApplicationLayouts, ApplicationStore, OpenIdService } from '@workspace/ng-data-access';
import { firstValueFrom } from 'rxjs';

export const provideAppInitialization: EnvironmentProviders = provideAppInitializer(async () => {
  const appStore = inject(ApplicationStore);
  const openId = inject(OpenIdService);

  registerLocaleData(localeFr);
  appStore.loadApplication({
    name: UserApplications.ADMIN,
    layout: ApplicationLayouts.CLASSY,
  });

  try {
    await firstValueFrom(openId.initialize());
  } catch (error) {
    console.error('App Initialization failed unexpectedly', error);
  }
});
